<!-- <div *ngIf="notFound">
<app-error-page [errorCode]="'404'"></app-error-page>
</div> -->

@if (!notFound) {
  <div>
    @if (!loading) {
      <app-work-order-navigation></app-work-order-navigation>
    }
    <main class="container" [class.split-active]="showSplitView">
      @if (hasStatusBanner()) {
        <div class="offline-fallback-banner" [ngClass]="getStatusBannerClass()">
          <mat-icon aria-hidden="true" [class.syncing-icon]="onlineSyncBannerState === 'syncing'">{{
            getStatusBannerIcon()
          }}</mat-icon>
          <div class="offline-fallback-copy">
            @if (onlineSyncBannerState === 'syncing') {
              <span>Back online. Trying to save your changes...</span>
            } @else if (onlineSyncBannerState === 'saved') {
              <span>Changes saved successfully</span>
            } @else {
              @if (pendingChangeCount > 0) {
                <span
                  >You are offline. {{ pendingChangeCount }} {{ pendingChangeCount === 1 ? 'change' : 'changes' }} made
                  while offline.</span
                >
              } @else {
                <span>You are viewing downloaded offline data. Some information may be outdated.</span>
              }
              @if (lastDownloadedAt) {
                <div class="offline-fallback-timestamp">
                  Last downloaded: {{ lastDownloadedAt | date: 'dd.MM.yyyy HH:mm' }}
                </div>
              }
            }
          </div>
          @if (onlineSyncBannerState === 'saved') {
            <button
              mat-icon-button
              class="status-close-button"
              (click)="dismissSavedBanner()"
              aria-label="Close status banner"
            >
              <mat-icon>close</mat-icon>
            </button>
          } @else if (isOfflineFallback) {
            <button
              mat-stroked-button
              class="offline-retry-button"
              (click)="retryLoadWorkOrder()"
              [disabled]="isRetryingOnline || !isOnline"
            >
              @if (!isRetryingOnline) {
                Retry online
              } @else {
                Retrying...
              }
            </button>
          }
        </div>
      }
      @if (loadErrorMessage && !isOfflineFallback) {
        <div class="offline-fallback-banner status-offline">
          <mat-icon aria-hidden="true">error_outline</mat-icon>
          <div class="offline-fallback-copy">
            <span>{{ loadErrorMessage }}</span>
          </div>
        </div>
      }
      @if (loading) {
        <div>
          <mat-spinner diameter="30"></mat-spinner>
        </div>
      }
      @if (!loading) {
        <div class="main-panel">
          <router-outlet></router-outlet>
        </div>
        @if (showSplitView) {
          <div class="split-resizer" (mousedown)="startResize($event)" (touchstart)="startResizeTouch($event)">
            <div class="split-resizer-handle"></div>
          </div>
          <div class="split-panel" [style.width.px]="splitPanelWidth">
            <app-work-order-documents></app-work-order-documents>
          </div>
        }
      }
    </main>
  </div>
}
